import styled from 'styled-components';
import PlanButton from 'Components/PlanButton';
import { pxToRem } from 'Styles/utils/utils';
import { FRONT_PLANS } from 'Constants/plans';

export const MGMButton = styled(PlanButton)`
  display: ${({ type }) =>
    type === FRONT_PLANS.BASIC || type === FRONT_PLANS.PRO ? 'flex' : 'none'};
  > div > div {
    margin-right: ${pxToRem(5)};
  }
  margin-left: ${({ theme: { sizing } }) => sizing.fds_size_16};
`;
